/** @jsx jsx */
import { jsx } from '@emotion/core';
import Button from 'components/Button';
import useTranslate from 'hooks/useTranslate';
import { FC, useCallback, useMemo } from 'react';
import { InstantCredit } from 'state/instantCredit';
import useAnalytics, { Event } from 'hooks/useAnalytics';

interface PropTypes {
  className?: string;
  callId?: string;
  instantCredit: InstantCredit;
  variant: 'text' | 'outlined' | 'contained' | undefined;
}

const ShopOnlineButton: FC<PropTypes> = ({ variant, instantCredit }) => {
  const t = useTranslate();

  const { sendEvents } = useAnalytics();

  const onPress = useCallback(() => {
    sendEvents([Event.ApplyAndBuy]);
  }, [sendEvents]);

  const linkProps = useMemo(() => {
    return {
      href: t('dsp.offer.shopOnlineUrl', { callId: instantCredit.callId }),
      target: '_blank',
      rel: 'noopener noreferrer',
    };
  }, [instantCredit.callId, t]);

  return (
    <Button component="a" onClick={onPress} variant={variant} {...linkProps}>
      {t('dsp.offer.shopButton')}
    </Button>
  );
};

export default ShopOnlineButton;
